import { Component, inject, OnInit, signal } from '@angular/core';
import { NgClass } from '@angular/common';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { LayoutService } from '../../layouts/layout.service';

interface SubNavItem {
  label: string;
  description: string;
  route: string;
  icon: string;
}

const SUB_NAV_ITEMS: SubNavItem[] = [
  {
    label: 'Programs',
    description: 'Manage active organizational units and program visibility settings.',
    route: '/configuration/programs',
    icon: 'programs',
  },
  {
    label: 'Categories & Taxonomies',
    description: 'Maintain primary incident classifications and program-specific frameworks.',
    route: '/configuration/categories',
    icon: 'categories',
  },
  {
    label: 'Data Elements',
    description: 'Define custom data fields and temporary capture requirements.',
    route: '/configuration/data-elements',
    icon: 'data-elements',
  },
  {
    label: 'Rollup Taxonomies',
    description: 'Configure data aggregation points and global reporting hierarchies.',
    route: '/configuration/rollup-taxonomies',
    icon: 'rollup-taxonomies',
  },
];

@Component({
  selector: 'app-configuration',
  imports: [RouterLink, RouterLinkActive, RouterOutlet, NgClass],
  templateUrl: './configuration.html',
})
export class ConfigurationComponent implements OnInit {
  private layout = inject(LayoutService);

  protected subNavItems = SUB_NAV_ITEMS;
  protected mobileView = signal<'list' | 'content'>('list');

  protected onNavClick(): void {
    this.mobileView.set('content');
  }

  protected goBack(): void {
    this.mobileView.set('list');
  }

  ngOnInit(): void {
    this.layout.set({
      title: 'Configuration',
      breadcrumb: '',
    });
  }
}
